export default __webpack_public_path__ + "static/media/GalanoGrotesque.379db1f3.woff2";